<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
      row-id="prjCategoryCode"
      >
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.prjCategoryStatus === 'Y' ? 'success' : 'danger'"
        >
          {{ row.prjCategoryStatusName }}
        </el-tag>
      </template>

      <template v-slot:sample="{row}">
        <el-tag
          size="mini"
          :type="row.isSample === 'Y' ? 'success' : 'danger'"
        >
          {{ row.isSampleName }}
        </el-tag>
      </template>

      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'detail',
                  code: row.prjCategoryCode
                })
              "
            ></i>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'edit',
                  code: row.prjCategoryCode
                })
              "
              v-if="allow('M')"
            ></i>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.prjCategoryCode)"
              v-show="row.prjCategoryStatus === 'Y'"
              v-if="allow('D')"
            ></i>
          </el-tooltip>
        </div>
      </template>

      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import TableAutoHeight from '@/mixins/table-auto-height'

export default {
  mixins: [TableAutoHeight],
  props: {
    tablePage: {
      default: null,
      type: Object
    },
    tableData: {
      default: () => [],
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => {
            this.$emit('submit')
          }
        },
        zoom: true,
        custom: true
      },
      tableColumn:[
        {
          field: 'seq',
          width: 50,
          fixed: 'left',
          align: 'center',
          type: 'seq'
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          fixed: 'right',
          width: 110,
          slots: {
            default: 'opt'
          }
        },
        {
          field: 'prjCategoryName',
          minWidth: 250,
          title: this.$l("table_head_chineseName") || "中文名称",
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          align: 'left'
        },
        {
          field: 'prjCategoryEnName',
          minWidth: 250,
          title: this.$l("table_head_englishName") || "英文名称",
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          align: 'left'
        },
        {
          field: 'isSampleName',
          width: 120,
          title: this.$l("table_label_isSampleName") || "是否打样",
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          align: 'center',
          slots: {default: "sample"}
        },
        {
          field: 'prjCategoryStatusName',
          width: 80,
          title: this.$l('table_head_status') || '有效状态',
          align: 'center',
          slots: { default: 'status' }
        },
      ],
    };
  },
  methods: {
    del(prjCategoryCode) {
      this.$confirm(
        this.$l("INDEX.tips_question_delete") || "是否删除？",
        this.$l("INDEX.tips_question_title") || "提示",
        {
          confirmButtonText: this.$l("INDEX.tips_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.tips_cancel") || "取消",
          type: "warning",
        }
      ).then(() => {
        let thismap = [prjCategoryCode]
        this.$api
          .prjCategoryDelApi({
            prjCategoryCodeList: thismap.map((item) =>
              item.prjCategoryCode ? item.prjCategoryCode : item
            ),
          })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l("INDEX.tips_delete_ok") || "删除成功！",
              type: "success",
            });
            this.$emit("submit");
          });
      });
    },
    // delRow(val) {
    //   this.multipleSelection = [val];
    //   this.del();
    // },
    // del() {
    //   if (!this.multipleSelection || this.multipleSelection.length < 1) {
    //     this.$message({
    //       showClose: true,
    //       message: "请选择需要删除的数据",
    //       type: "warning",
    //     });
    //     return;
    //   }
    //   this.$confirm("是否删除？").then((_) => {
    //     this.$api
    //       .prjCategoryDelApi({
    //         prjCategoryCodeList: this.multipleSelection.map((item) =>
    //           item.prjCategoryCode ? item.prjCategoryCode : item
    //         ),
    //       })
    //       .then((res) => {
    //         this.$message({
    //           showClose: true,
    //           message: "删除成功",
    //           type: "success",
    //         });
    //         this.$emit("submit");
    //       });
    //   });
    // },
  },
};
</script>
